import { Dialog } from "@mui/material";
import { ModalBody, ModalFooter, ModalTitle } from "@vds/modals";
import { Body, Title } from "@vds/typography";
import { CVAPPS_TEST_IDS } from "./cvAppsConstants";

export const DeleteCVAppModal=(props)=>{
    const{
        message,
        title,
        onConfirm,
        onExit,
        setShowDeleteCVApp,
        showDeleteCVApp,

    }=props;

    return(
        <>
            <Dialog
            open={showDeleteCVApp}
            aria-label="Create group modal"
            fullWidthh={true}
            maxWidth={"sm"}
            opened={showDeleteCVApp}
            disableOutsideClick={true}
            // ariaLabel={`${title}Modal`}
            surface="light"
            >
        
            
                <div style={{margin: "3%"}}>
                    <ModalTitle>
                        <Title size="large">{title}</Title>
                    </ModalTitle>
                    <ModalBody>
                        <Body size="large">
                            {message || "Do you want to delete CVApp"}
                        </Body>
                    </ModalBody>
                    <ModalFooter
                    buttonData={{
                        primary: {
                            widthhh:"150px",
                            children: "Yes",
                            onClick: onConfirm,
                            "data-testid": CVAPPS_TEST_IDS.CVAPPS_DELETE_MODAL_CONFIRM_BUTTON,
                        },
                        close: {
                            children:"No",
                            width:"150px",
                            onClick: onExit,                        
                            "data-testid": CVAPPS_TEST_IDS.CVAPPS_DELETE_MODAL_CLOSE_BUTTON,
                        }
                    }}
                    />
                </div>

            
            </Dialog>
        </>

    );
};





